/*
Author: Hoi Tak Leung
Email: hoi.leung@greedy.mx
Last Update: 26/09/2023
*/

import { Typography, Container } from "@mui/material";

import ServicesSection from "./section-services/ServicesSection";
import IndustriesSection from "./section-industries/IndustriesSection";
import AboutSection from "./section-about-us/AboutSection";
import ContactSection from "./section-contact/ContactSection";

import "./Landing.css";
import backgroundVideo from "../../assets/1100606505-preview.mp4";
import backgroundImgMobile from "../../assets/landing-page/landing_sm_back.webp";

import { PortfolioSection } from "./section-portfolio/PortfolioSection";
import { useScrollReveal } from "../../helpers/ScrollReveal";
import { useLanguageContext } from "../../context/languageContext";
import { textlanguages } from "../../data/textOfThePage";

export default function Landing() {
  const { languageSelected } = useLanguageContext();

  useScrollReveal([
    {
      selector: ".revealFromCenter",
      options: {
        distance: "0px",
        duration: 1000,
        easing: "ease-out",
        origin: "center",
        reset: false,
      },
    },
  ]);

  return (
    <Container disableGutters maxWidth={false} className="landing-container">
      <Container
        maxWidth={false}
        disableGutters
        sx={{ display: { xs: "none", sm: "none", lg: "block", xl: "block" } }}
        className="container-video revealFromCenter"
      >
        <video autoPlay loop muted id="background-video">
          <source src={backgroundVideo} type="video/mp4" />
        </video>
        <Typography variant="h2" className="video-overlay">
          {textlanguages[languageSelected].mainPage.sectionOne.title} <br />
          {textlanguages[languageSelected].mainPage.sectionOne.titleSecondRow}
        </Typography>
      </Container>
      <Container
        sx={{ display: { xs: "block", sm: "block", lg: "none", xl: "none" } }}
        maxWidth={false}
        disableGutters
      >
        <img
          src={backgroundImgMobile}
          className="background-image"
          alt="Imagen de Fondo Tecnología"
        />
      </Container>
      <div id="section-services">
        <ServicesSection showCarrusel />
      </div>
      <div id="section-industries">
        <IndustriesSection />
      </div>
      <div id="section-portfolio">
        <PortfolioSection />
      </div>
      <div id="section-about-us">
        <AboutSection />
      </div>
      <div id="section-contact">
        <ContactSection />
      </div>
    </Container>
  );
}
